import {createContext} from 'react';

import type {ImmersiveOnboardingResult} from 'common/report/queries/app-api/immersive-onboarding';

export enum Step {
  Welcome = `welcome`,
  Events = `events`,
  Implement = `implement`,
  Explore = `explore`,
}

export const SetupGuideContext = createContext<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  step: Step;
  setStep: React.Dispatch<React.SetStateAction<Step>>;
  setupGuideInfo: ImmersiveOnboardingResult;
  setSetupGuideInfo: React.Dispatch<React.SetStateAction<ImmersiveOnboardingResult>>;
  isIntegrated: boolean;
  setIsIntegrated: React.Dispatch<React.SetStateAction<boolean>>;
}>(null);

export const VisibilityContext = createContext<{
  visibility: boolean;
  setVisibility: React.Dispatch<React.SetStateAction<boolean>>;
}>(null);
